export const CULTURE_FEATURE_LIST = [
  {
    image: "/assets/careers/work-culture.webp",
    alt: "Exhilarating Work Culture",
    heading: "Exhilarating Work Culture",
    width: 45,
  },
  {
    image: "/assets/careers/technology-stacks.webp",
    alt: "Advanced Technology Stacks",
    heading: "Advanced Technology Stacks",
    width: 48,
  },
  {
    image: "/assets/careers/high-exposure.webp",
    alt: "High Exposure in different Areas",
    heading: "High Exposure in different Areas",
    width: 45,
  },
  {
    image: "/assets/careers/pay-scale.webp",
    alt: "Appealing Payscale",
    heading: "Appealing Payscale",
    width: 45,
  },
  {
    image: "/assets/careers/prominent-workspace.webp",
    alt: "Prominent Workspace",
    heading: "Prominent Workspace",
    width: 46,
  },
  {
    image: "/assets/careers/no-secret-policies.webp",
    alt: "No Secret Policies",
    heading: "No Secret Policies",
    width: 45,
  },
  {
    image: "/assets/careers/hierarchical-structure.webp",
    alt: "An Open Hierarchical Structure",
    heading: "An Open Hierarchical Structure",
    width: 45,
  },
  {
    image: "/assets/careers/career-opportunity.webp",
    alt: "Exponential Career Opportunity",
    heading: "Exponential Career Opportunity",
    width: 45,
  },
];
